import { Directive, ElementRef, HostListener } from '@angular/core';
import { EnterPressClassSelector } from './enter-press.config';

@Directive({
  selector: '[EnterPress]',
  standalone: false,
})
export class EnterPressDirective {
  button: HTMLElement;
  scannedPage = false;

  @HostListener('document:keydown.enter', ['$event'])
  onKeydownHandler(event: KeyboardEvent): void {
    if (this.button) {
      this.clickOnButton();
    } else if (!this.scannedPage) {
        this.findAllButtons();
        this.onKeydownHandler(null);
      }
  }

  constructor(private readonly ref: ElementRef) {}

  findAllButtons(): void {
    this.button = this.ref.nativeElement.querySelector(`.${EnterPressClassSelector} button`);
    this.scannedPage = true;
  }

  clickOnButton(): void {
    const activeElementIsButton = document.activeElement instanceof HTMLButtonElement;
    if (activeElementIsButton) {
      const activeElem = document.activeElement as HTMLButtonElement;
      activeElem.blur();
    }
    return this.button.click();
  }
}
